import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { initSentry, Sentry } from "./lib/sentry";
import "./stores/theme";
import "./styles.css";

declare const __GAOLE_BUILD_SHA__: string;
declare const __GAOLE_BUILD_TIME__: string;

if (import.meta.env.PROD) {
  console.info(
    `[gaole-backoffice] build ${__GAOLE_BUILD_SHA__} @ ${__GAOLE_BUILD_TIME__} bottomBar=sync-v2`,
  );
}

initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: true },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p className="p-6 text-center text-muted">Something went wrong.</p>}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
